import { FilterKeywords, FiltersModel } from "../../../common";

export class ItemsFiltersModel extends FiltersModel {
  containerNumber: string;
  type: string;
  shipped: string;
  startDate: Date;
  itemNumber: string;
  containerDetail: string;
  itemDetail: string;
  streamName: string;

  constructor(state?: string) {
    super();

    this.setState(state);
  }

  setState(input: string): string {
    input = super.setState(input);

    if (!input) return;

    let mappings: FilterKeywords[] = [
      {
        keyword: "type",
        setter: (value) => (this.type = this.clean(value)),
      },
      {
        keyword: "shipped",
        setter: (value) => (this.shipped = this.yesOrNo(value)),
      },
      {
        keyword: "start-date",
        setter: (value) => (this.startDate = new Date(value)),
      },
      {
        keyword: "item-detail",
        setter: (value) => (this.itemDetail = value),
      },
      {
        keyword: "container-number",
        setter: (value) => (this.containerNumber = value),
      },
      {
        keyword: "container-detail",
        setter: (value) => (this.containerDetail = value),
      },
      {
        keyword: "stream-name",
        setter: (value) => (this.streamName = value),
      },
      {
        keyword: "id",
        setter: (value) => (this.itemNumber = value),
      },
    ];

    mappings.forEach((mapping) => {
      input = this.testValues(input, mapping);
    });

    return null;
  }

  getState(): string {
    let filters: string[] = [],
      superState = super.getState();

    if (this.itemNumber) filters.push(this.encode(this.itemNumber));
    if (this.type) filters.push(`type-${this.encode(this.type)}`);
    if (this.shipped) filters.push(`shipped-${this.encode(this.shipped)}`);
    if (this.startDate) filters.push(`start-date-${this.startDate.toLocaleDateString()}`);
    if (this.containerNumber) filters.push(`container-number-${this.encode(this.containerNumber)}`);
    if (this.containerDetail) filters.push(`container-detail-${this.encode(this.containerDetail)}`);
    if (this.streamName) filters.push(`stream-name-${this.encode(this.streamName)}`);
    if (this.itemDetail) filters.push(`item-detail-${this.encode(this.itemDetail)}`);

    if (superState) filters.push(superState);

    return filters.join(" ");
  }

  public serializeFrom(stateBug: {}): void {
    Object.keys(stateBug).forEach((key) => {
      let value = decodeURI(stateBug[key]).trim();
      switch (key) {
        case "id":
          this.itemNumber = value;
          break;
        case "type":
          this.type = value;
          break;
        case "shipped":
          this.shipped = value;
          break;
        case "startDate":
          this.startDate = new Date(value);
          break;
        case "containerNumber":
          this.containerNumber = value;
          break;
        case "containerDetail":
          this.containerDetail = value;
          break;
        case "streamName":
          this.streamName = value;
          break;
        case "itemDetail":
          this.itemDetail = value;
          break;
      }
    });
  }

  public serializeTo(stateBug: {}): void {
    if (this.itemNumber) stateBug["id"] = this.itemNumber.trim();
    if (this.type) stateBug["type"] = this.type.trim();
    if (this.startDate) stateBug["startDate"] = this.startDate;
    if (this.containerNumber) stateBug["containerNumber"] = this.containerNumber;
    if (this.containerDetail) stateBug["containerDetail"] = this.containerDetail;
    if (this.streamName) stateBug["streamName"] = this.streamName;
    if (this.itemDetail) stateBug["itemDetail"] = this.itemDetail;
  }
}
